import { getRtlDirectionOverrideMd } from '#pplx/frontend/i18n/textDirection.js';
import { useRef } from 'react';
const MIN_SAMPLE_LENGTH = 40;
export function useStreamingTextDirection(chunks) {
    const decidedRef = useRef(false);
    const directionRef = useRef(undefined);
    if (!decidedRef.current) {
        let sample = '';
        for (const chunk of chunks) {
            const remainingSampleLength = MIN_SAMPLE_LENGTH - sample.length;
            sample += chunk.slice(0, remainingSampleLength);
            if (sample.length >= MIN_SAMPLE_LENGTH)
                break;
        }
        if (sample.length >= MIN_SAMPLE_LENGTH) {
            directionRef.current = getRtlDirectionOverrideMd(sample);
            decidedRef.current = true;
        }
    }
    return directionRef.current;
}
//# sourceMappingURL=useStreamingTextDirection.js.map